module.exports = __webpack_public_path__ + "static/030-9f1d786272a2bc9e7cef020f9ffba75f.jpg";